import { type IconProp, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fass } from '@fortawesome/sharp-solid-svg-icons';
import type { IHeaderParams } from 'ag-grid-enterprise';

library.add(fass);

export type ICustomInnerHeaderParams = {
  icon: string;
};

const InnerHeaderWithIcon = (params: ICustomInnerHeaderParams & IHeaderParams) => {
  const { displayName, icon } = params;

  if (!icon) {
    return <span>{displayName}</span>;
  }

  // @ts-expect-error adding by instruction of https://docs.fontawesome.com/web/use-with/react/add-icons
  const myIcon: IconProp = ['fa-sharp', icon];

  return (
    <>
      <FontAwesomeIcon
        className="mr-2"
        icon={myIcon}
      />
      <span>{displayName}</span>
    </>
  );
};

export default InnerHeaderWithIcon;
